import { useApi } from '../api/useApi';
import { mediaUrl } from '../api/client';
import Loader from './ui/Loader';
import SectionHeader from './ui/SectionHeader';

export default function Clients() {
  const { data: clients, loading } = useApi('/clients', 'clients');
  const items = clients?.length ? [...clients, ...clients] : [];

  return (
    <section className="section section--clients" id="clients">
      <div className="container">
        <SectionHeader
          eyebrow="Clientes"
          title="Empresas que confían en nosotros"
          subtitle="Hemos acompañado a organizaciones de distintos sectores en sus retos legales."
        />
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className="clients-marquee" aria-label="Logos de clientes">
          <div className="clients-marquee__track">
            {items.map((client, index) => (
              <div key={`${client.id}-${index}`} className="clients-marquee__item">
                {client.logo_url ? (
                  <img src={mediaUrl(client.logo_url)} alt={client.name} loading="lazy" />
                ) : (
                  <span>{client.name}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
